import type { ImgHTMLAttributes } from 'react'
import { mediaSizes, mediaSrcSet, mediaUrl, type MediaSize } from '../lib/media'

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src?: string
  size?: MediaSize
  priority?: boolean
}

export default function MediaImage({
  src,
  size = 'card',
  alt = '',
  priority = false,
  sizes,
  loading,
  fetchPriority,
  decoding,
  ...props
}: Props) {
  if (!src) return null

  const srcSet = mediaSrcSet(src, size)

  return (
    <img
      src={mediaUrl(src, size)}
      srcSet={srcSet}
      sizes={srcSet ? (sizes ?? mediaSizes(size)) : sizes}
      alt={alt}
      loading={loading ?? (priority ? 'eager' : 'lazy')}
      fetchPriority={fetchPriority ?? (priority ? 'high' : 'auto')}
      decoding={decoding ?? (priority ? 'sync' : 'async')}
      {...props}
    />
  )
}
